import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ExportWallet } from '@root/features/wallet/export-wallet/ui/common/export-wallet'

import { walletsManagerModelAtom } from '../../atoms'

import { WalletDetailsSection } from './wallet-details-section'

import type { WalletModel } from '@root/entities/wallet'

export type WalletDetailsExportProps = {
  wallet: WalletModel
}
export const WalletDetailsExport: React.FC<WalletDetailsExportProps> = ({
  wallet,
}) => {
  const { t } = useTranslation()
  const [model] = useAtom(walletsManagerModelAtom)
  const clearSelectedWallet = useAction(model.clearSelectedWallet)

  const [_, setScreen] = useAtom(model.walletDetailsScreen)

  const onBack = () => {
    setScreen('edit')
  }

  return (
    <Root
      title={t('wallet.export_wallet')}
      onBack={onBack}
      onClose={clearSelectedWallet}
    >
      <ExportWallet wallet={wallet} onClose={onBack} device="desktop" />
    </Root>
  )
}

const Root = styled(WalletDetailsSection)`
  ${WalletDetailsSection.Content} {
    padding-inline: 12px;
    padding-block: 10px;
  }
`
